module.exports = __webpack_public_path__ + "static/media/5-wood.1750c608.png";